import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrudPurchaseOrderDetailsService {
   _baseUrl = environment.baseUrl;
    options = {
      headers: new HttpHeaders({ "x-api-version": "2.0" }),
      withCredentials: true,
    };

  constructor(private readonly httpClient: HttpClient) { }
  
    getPoDetailById(model: any) {
    return this.httpClient.post<any>(
      `${this._baseUrl}FindiAssetPo/GetPurchaseOrderDetailsByPoId`,
      model,
      this.options
    );
  }

  deletePurchaseOrderDetails(model:any)
  {
     return this.httpClient.post<any>(
      `${this._baseUrl}FindiAssetPo/DeletePurchaseOrderDetails`,
      model,
      this.options
    );
  }

  updatePurchaseOrderDetail(model:any)
  {
     return this.httpClient.post<any>(
      `${this._baseUrl}FindiAssetPo/UpdatePurchaseOrderDetail`,
      model,
      this.options
    );
  }

  addMorePurchaseOrderDetails(model:any)
  {
     return this.httpClient.post<any>(
      `${this._baseUrl}FindiAssetPo/AddMorePurchaseOrderDetails`,
      model,
      this.options
    );
  }

    getSampleForBulkPoDetailsUpload(): any {
    let options = {
      headers: new HttpHeaders({"x-api-version": "2.0"}),
      withCredentials: true,
      responseType: "blob" as "json", // Type assertion needed for blob responses
    };

    return this.httpClient.get(
      this._baseUrl + "FindiAssetPo/GetSampleForBulkPoDetailsUpload",
      options
    );
  }

    uploadFileForBulkPoDetails(model: any): Observable<any> {
        return this.httpClient.post<any>(
          this._baseUrl + "FindiAssetPo/UploadFileForBulkPoDetails",
          model, this.options
        );
      }


}
